module.exports = __webpack_public_path__ + "img/smile-bird.81cdbba.png?v=1764903765445";